import React from 'react';
import {
  IconChatNotification, IconCursor, IconGlobeCursor, IconThumb, IconExternalLinkV2,
} from 'gatorcomponents';

export default {
  adsHandler: {
    firstRow: {
      tag: 'Com inteligência artificial',
      title: 'Crie anúncios que vendem de verdade no Facebook e Instagram!',
      list: [
        'Agora você tem um agente de IA especializado em anúncios',
        'Receba ideias, textos e estratégias feitas sob medida para o seu negócio',
        'Alcance quem interessa, com menos esforço e mais resultado',
      ],
      cta: 'Falar com o agente',
      ctaDescription: 'Aproveite! Está liberado no seu plano.',
    },
    secondRow: {
      title: 'Confira tudo que o Agente de Marketing pode fazer pelo seu negócio!',
      faqItems: [
        {
          title: 'Para quem é o Agente de Marketing?',
          content: {
            text: 'O Agente de Marketing é ideal para pequenos e médios empreendedores, autônomos e iniciantes em anúncios online. Ele atende quem deseja divulgar seu negócio no Facebook e Instagram.',
          },
        },
        {
          title: 'O que esse agente de IA faz?',
          content: {
            text: 'Ela entende o seu negócio, cria toda a estrutura da campanha no Facebook Ads e explica tudo de maneira fácil, sem precisar que você entenda de tráfego ou segmentação.',
          },
        },
        {
          title: 'Com quais tarefas o Agente de Marketing pode me ajudar?',
          content: {
            title: 'Ele pode:',
            list: [
              'Entender o seu negócio e público-alvo;',
              'Sugerir o melhor tipo de campanha, público, orçamento e formato de anúncio para Facebook e Instagram;',
              'Criar textos e imagens para os anúncios;',
              'Explicar o passo a passo para configurar e publicar os anúncios;',
              'Orientar sobre políticas do Facebook, recomendações de boas práticas e ajustes na campanha;',
              'Sugerir ideias para postagens, calendário de publicações e outras estratégias digitais.',
              'Ajuda para criação de anúncios no HostGator Studio',
              'Campanhas de E-mail marketing',
            ],
          },
        },
        {
          title: 'Como devo usar o Agente de Marketing?',
          content: {
            text: 'Conte sobre o seu negócio, o que deseja anunciar e para quem quer vender. Ele vai te fazer algumas perguntas simples, sugerir as melhores estratégias e te mostrar passo a passo como configurar e publicar sua campanha no Gerenciador de Anúncios do Facebook. Você só precisa seguir as instruções e, se precisar, pedir ajuda para ajustes ou outras dúvidas.',
          },
        },
      ],
    },
    projects: {
      yourProjectsLabel: 'Seus projetos',
      createNewProjectLabel: 'Criar novo projeto',
      createdAt: ({ day, month }) => `Criado em ${day} de ${month}`,
    },
  },
  maiaLocales: {
    welcome: name => (
      <div>
        <span>
          {`Olá ${name}, `}
        </span>
        O que você quer criar ou divulgar hoje?
      </div>
    ),
    suggestions: 'Se preferir, escolha uma opção:',
    options: [
      {
        icon: IconExternalLinkV2,
        tag: 'Novo',
        label: 'Criar plano de anúncios pagos',
        initialMessage: 'Me ajude a criar plano de anúncios pagos para redes sociais',
        action: 'marketing',
      },
      {
        icon: IconGlobeCursor,
        label: 'Aprender a criar a página da sua empresa no Google',
        initialMessage: 'Me ajude a configurar o Google Meu Negócio',
        action: 'marketing',
      },
      {
        icon: IconThumb,
        label: 'Criar mensagens para posts nas redes sociais',
        initialMessage: 'Me ajude a criar posts para redes sociais',
        action: 'marketing',
      },
      {
        icon: IconChatNotification,
        label: 'Divulgar ofertas no WhatsApp',
        initialMessage: 'Me ajude a divulgar ofertas no WhatsApp',
        action: 'marketing',
      },
      {
        icon: IconCursor,
        label: 'Criar estratégias para aumentar o engajamento',
        initialMessage: 'Me ajude a aumentar meu engajamento',
        action: 'marketing',
      },
    ],
    askMaiaPlaceholder: 'Converse com o Gator...',
  },
};
